import React from 'react';
import { rankWith, UISchemaElement, JsonSchema } from '@jsonforms/core';

// 1. Visual Fallback Component that shows exactly what broke
const CatchAllDebugComponent = ({ uischema, schema }: { uischema: UISchemaElement, schema: JsonSchema }) => {
  const scope = 'scope' in uischema ? (uischema as any).scope : 'None (Layout Container)';
  
  return (
    <div style={{
      padding: '15px',
      margin: '10px 0',
      border: '2px dashed #ff4d4f',
      backgroundColor: '#fff2f0',
      color: '#ff4d4f',
      fontFamily: 'monospace',
      borderRadius: '4px'
    }}>
      <h4 style={{ margin: '0 0 8px 0' }}>❌ Missing Renderer Detected</h4>
      <div><strong>UI Element Type:</strong> {uischema.type}</div>
      <div><strong>Schema Scope:</strong> {scope}</div>
      <details style={{ marginTop: '8px' }}>
        <summary style={{ cursor: 'pointer', color: '#1890ff' }}>View Raw UI Element Definition</summary>
        <pre style={{ background: '#fafafa', padding: '8px', marginTop: '5px', overflowX: 'auto' }}>
          {JSON.stringify(uischema, null, 2)}
        </pre>
      </details>
    </div>
  );
};

// 2. Lowest priority tester (Rank: 0) - matches everything but runs LAST
export const catchAllTester = rankWith(0, () => true);

export const catchAllDebugRenderer = {
  tester: catchAllTester,
  renderer: CatchAllDebugComponent
};